import React from "react";
import { motion } from "framer-motion";

// Fade-up on scroll into view
export const Reveal = ({ children, delay = 0, y = 34, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

// Masked line-by-line reveal for headings. Plays on mount (hero).
export const MaskedLines = ({ lines, className = "", delay = 0, stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * stagger, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Kicker = ({ children, className = "" }) => (
  <Reveal className={`flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-[var(--gold)]/60" />
    <span className="font-sans text-[11px] uppercase tracking-[0.32em] text-[var(--gold)]">
      {children}
    </span>
  </Reveal>
);
